module.exports = __webpack_public_path__ + "static/media/pr.b55721a5.svg";